exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bread-crumb[data-v-c5eb2104]{font-family:Microsoft YaHei}", ""]);

// exports
